import React from 'react';
import { titleCase } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/utils/string.tsx';
import type { Props } from './types.tsx';

export default function TypeCell({ direction, row: { type } }: Props) {
	return <>{titleCase(type[direction])}</>;
}
